import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CheckoutService } from '@checkout-v2/feature';
import { CustomOrder } from '@order/const';
import { SdvorLinkComponent } from '@sdvor/shared/ui';
import { UrlModule } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'sd-order-confirmation-info-body',
  templateUrl: './order-confirmation-info-body.component.html',
  styleUrls: ['./order-confirmation-info-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, UrlModule, RouterLink, SdvorLinkComponent],
})
export class OrderConfirmationInfoBodyComponent implements OnInit {
  order$: Observable<CustomOrder>;

  constructor(private checkoutService: CheckoutService) {}

  ngOnInit(): void {
    this.order$ = this.checkoutService
      .getOrderDetails()
      .pipe(filter<CustomOrder>((order) => Object.keys(order || {}).length > 0));
  }
}
